export default "__VITE_ASSET__Cvtknnbk__"